"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTypeaheadSuggestionsEndpointRequest = void 0;
const ProductWith_1 = require("../../types/ProductWith");
const attributes_1 = require("../../helpers/attributes");
function createTypeaheadSuggestionsEndpointRequest(parameters) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        method: 'POST',
        endpoint: `typeahead`,
        params: Object.assign({ term: parameters.term, with: [
                ...(((_a = parameters.with) === null || _a === void 0 ? void 0 : _a.products)
                    ? (0, attributes_1.prefixList)('product.')((0, ProductWith_1.productWithQueryParameterValues)((_b = parameters.with) === null || _b === void 0 ? void 0 : _b.products))
                    : []),
                ...(((_d = (_c = parameters.with) === null || _c === void 0 ? void 0 : _c.categories) === null || _d === void 0 ? void 0 : _d.parents) == 'all'
                    ? ['category.parents']
                    : []),
                ...(((_f = (_e = parameters.with) === null || _e === void 0 ? void 0 : _e.categories) === null || _f === void 0 ? void 0 : _f.children) ? ['category.children'] : []),
            ].join(`,`) }, (((_h = (_g = parameters.with) === null || _g === void 0 ? void 0 : _g.categories) === null || _h === void 0 ? void 0 : _h.children)
            ? { categoryDepth: ((_k = (_j = parameters.with) === null || _j === void 0 ? void 0 : _j.categories) === null || _k === void 0 ? void 0 : _k.children) + 1 }
            : undefined)),
        data: Object.assign(Object.assign({}, (parameters.categoryId
            ? { categoryId: parameters.categoryId }
            : undefined)), (parameters.productLimit != null
            ? { limit: parameters.productLimit }
            : undefined)),
    };
}
exports.createTypeaheadSuggestionsEndpointRequest = createTypeaheadSuggestionsEndpointRequest;
